<template>
  <div class="main-style">
    <el-backtop target=".main-style"></el-backtop>

    <!-- 客服 -->
    <!-- <div class="line-service">
      <div class="service-img">
        <img src="@/assets/image/index/service.png" alt="">
      </div>
      <div class="text">在</div>
      <div class="text">线</div>
      <div class="text">客</div>
      <div class="text">服</div>
      <div class="text-ask">咨询</div>
    </div> -->

    <div class="top">
      <div class="top-box">
        <div class="logo">
          <!-- <img src="https://via.placeholder.com/350x150"> -->
          <img src="@/assets/logo.png">

        </div>
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane @tab-click="tabHandleClick(item)" v-for="item in navList" :key="item.id" :label="item.navName"
            :name="item.id"></el-tab-pane>

        </el-tabs>
        <el-select class="select-right" v-model="pathVal" placeholder="请选择">
          <el-option v-for="item in navList" :key="item.id" :label="item.navName" :value="item.path">
          </el-option>
        </el-select>
      </div>


    </div>
    <div class="content">
      <router-view></router-view>
    </div>
    <div class="bottom">
      <div class="bottom-content">
        <div class="info">
          <div class="info-item">
            <div class="icon">
              <img src="@/assets/image/index/address.png" alt="">
            </div>
            <div class="trem">
              <div class="title">联系地址</div>

              <div class="text">湖北省武汉市汉阳区龙阳街道龙阳大道33号南国明珠二期1组团14栋3单元11层01室
              </div>
            </div>

          </div>
          <div class="info-item">
            <div class="icon">
              <img src="@/assets/image/index/phone.png" alt="">
            </div>
            <div class="trem">
              <div class="title">联系电话</div>
              <div class="text">18602728648</div>
            </div>

          </div>
          <div class="info-item">
            <!-- <div class="icon">
              <i class="el-icon-map-location"></i>
            </div> -->
            <div class="trem">
              <div class="title">联系邮箱</div>
              <div class="text">1197931985@qq.com</div>
            </div>

          </div>
        </div>
        <div class="about">
          <div class="about-link">
            <!-- <div class="link">天牙口腔动态</div>
            <div class="separate"></div> -->
            <!-- <div class="link">电话呼叫行业新闻</div>
            <div class="separate"></div> -->
            <div class="link" @click="bottomClick(0)">YOBONKE</div>
            <div class="separate"></div>
            <div class="link" @click="bottomClick(1)">电脑拨号软件下载</div>
            <div class="separate"></div>
            <div class="link" @click="bottomClick(2)">电脑拨号视频介绍</div>
            <div class="separate"></div>
            <div class="link" @click="bottomClick(3)">关于我们</div>
            <!-- <div class="separate"></div>
            <div class="link">ZOL应用下载</div>
            <div class="separate"></div>
            <div class="link">YOBONKEUSB电话问题</div>
            <div class="separate"></div>
            <div class="link">YOBONKE手机APP问题</div>
            <div class="separate"></div>
            <div class="link"> YOBONKE电话管理系统问题</div>
            <div class="separate"></div>
            <div class="link">电脑拨号视频介绍</div>
            <div class="separate"></div>
            <div class="link">电话助手教程演示</div> -->


          </div>
          <div class="copy-info">
            <div>©湖北省元一软件有限公司 版权所有
            </div>
            <div class="un-show">手机版丨管理登录丨鄂ICP备2025146371号
            </div>
            <div class="un-show phone">鄂ICP备2025146371号</div>
          </div>
          <!-- <div class="number-box">
            <div class="number">1</div>
            <div class="number">2</div>
            <div class="number">2</div>
            <div class="number">2</div>
            <div class="number">2</div>
            <div class="number">2</div>
            <div class="number">2</div>
            <div class="number">2</div>
          </div> -->
        </div>


      </div>



    </div>

    <!-- <div class="bottom-btn">
      <div class="btn-box">
        <div class="item-box">
          <div class="icon-box">
            <img src="@/assets/image/index/phoneb.png" alt="">

          </div>
          <div class="text">云邦客电话咨询</div>
        </div>
        <div class="item-box">
          <div class="icon-box">
            <img src="@/assets/image/index/down.png" alt="">

          </div>
          <div class="text">拨号软件试用</div>
        </div>
        <div class="item-box">
          <div class="icon-box">
            <img src="@/assets/image/index/qq.png" alt="">
          </div>
          <div class="text">拨号助手QQ客服</div>
        </div>
        <div class="item-box">
          <div class="icon-box">
            <img src="@/assets/image/index/computer.png" alt="">
          </div>
          <div class="text">云邦客电脑官网</div>
        </div>

      </div>

    </div> -->
  </div>
</template>

<script>


export default {
  name: 'homePage',
  data() {
    return {
      activeName: '0',
      navList: [
        {
          navName: '首页',
          path: '/',
          id: '0',
        },
        {
          navName: '电脑拨号软件下载',
          path: '/download',
          id: '1',
        },
        {
          navName: '电脑拨号视频介绍',
          path: '/introduction',
          id: '2',
        },

        {
          navName: '关于我们YOBONKE',
          path: '/about',
          id: '3',
        },

      ],
      pathVal: null,
    };
  },
  methods: {
    handleClick(tab, event) {
      console.log(tab.name, tab.index, event);
      this.$router.push(this.navList[tab.index].path)
    },
    bottomClick(i) {
      this.$router.push(this.navList[i].path)
      this.activeName = i + ''
    },


  }
}
</script>

<style lang="less" scoped>
.main-style {
  height: 100%;
  // display: flex;
  // flex-direction: column;
  // justify-content: space-between;
  overflow: auto;
  padding-top: 80px;
  box-sizing: border-box;



}

.line-service {
  position: absolute;
  right: 30px;
  top: 450px;
  width: 70px;
  height: 200px;
  background-color: #17d2dd;
  color: #fff;
  border-radius: 8px;
  font-size: 24px;
  font-weight: bold;
  z-index: 90;

  .service-img {
    width: 54px;
    height: 54px;
    margin: 10px auto 5px;

    img {
      width: 100%;
      height: 100%;
    }
  }

  .text-ask {
    display: none;
  }

  .text {
    /*  writing-mode 现代浏览器中广泛支持，包括 Chrome、Firefox、Safari 和 Edge。 */
    writing-mode: vertical-lr;
    /*兼容其他旧版本的浏览器 */
    -webkit-writing-mode: vertical-lr;
    text-align: center;
    margin: 0 auto 4px;
  }
}


.top {
  z-index: 999;
  position: absolute;
  top: 0;
  left: 0;
  height: 70px;
  // padding:0 20%;
  width: calc(100% - 12px);
  background: #fff;

  .select-right {
    display: none;
  }

  .top-box {
    height: 70px;
    width: 1200px;
    margin: 0 auto;

    display: flex;
    // justify-content: space-between;
    justify-content: start;

    .logo {
      height: 70px;
      width: 225px;
      height: 100%;
      position: relative;
      margin-right: 90px;

      // top: -12px;
      img {
        height: 100%;
      }
    }

  }

  /deep/ .el-tabs__nav-wrap::after {
    display: none;

  }

  /deep/ .el-tabs {
    display: flex;

    .el-tabs__header {
      margin-bottom: 0;

      .el-tabs__nav {
        height: 70px;
        display: flex;
        align-items: center;
      }
    }
  }

  /deep/ .el-tabs__nav-wrap .el-tabs__item {
    font-size: 16px;
    color: #2b2b2b;
    padding: 0 10px !important;
    border-radius: 4px;
    margin-right: 5px;

    &:hover {
      color: #fff;
      background: #009fe9;
    }

    &.is-active {
      color: #fff;
      background: #009fe9;
    }
  }

  /deep/ .el-tabs__active-bar {
    display: none;

  }



}

.bottom {
  background-color: #2b2b2b;
  padding: 20px 0;

  .bottom-content {

    width: 1200px;
    margin: 0 auto;
    color: #8b919d;

    .info {
      display: flex;
      justify-content: space-around;
      border-bottom: 1px solid #8b919d;
      color: #999;

      .info-item {
        display: flex;
        align-items: center;

        .icon {
          margin-right: 10px;
          width: 40px;
          height: 40px;


          img {
            width: 100%;
            height: 100%;
          }
        }

        .trem {
          .title {
            font-size: 14px;
            font-weight: bold;
          }
        }
      }
    }

    .about {
      .about-link {
        display: flex;
        justify-content: center;
        flex-wrap: wrap;

        .separate {
          height: 13px;
          width: 1px;
          background: #8b919d;
          margin: 9px 10px 0;
        }

        .link {
          cursor: pointer;
          font-size: 14px;
          line-height: 28px;

          &:hover {
            color: #fff;
          }
        }
      }

      .copy-info {
        display: flex;
        flex-direction: column;
        justify-self: center;
        color: #999;
        font-size: 14px;
        text-align: center;
      }

      .un-show {
        display: block;
      }


      .un-show.phone {
        display: none;
      }

      .number-box {
        display: flex;
        justify-content: center;
        padding-top: 10px;

        .number {
          width: 16px;
          height: 22px;
          background-color: #555555;
          color: #aaa;
          text-align: center;
          line-height: 22px;
          margin-right: 3px;

        }
      }
    }
  }

  // height: 100px;


}

.bottom-btn {
  display: none
}

.content {
  // background-color: blue;

  // height: 100%;
}

@media (max-width: 500px) {
  .main-style {
    padding-top: 0;
  }

  .line-service {
    top: 120px;
    right: 10px;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-image: linear-gradient(to right, #38e7c6, #37afb6);

    .service-img {
      width: 46px;
      height: 46px;
      margin: 5px auto 0px
    }

    .text {
      display: none;
    }

    .text-ask {
      text-align: center;
      display: block;
      font-weight: 400;
      font-size: 18px;
    }
  }


  .top {
    display: none;
    position: absolute;
    top: 0;
    left: 0;
    height: 70px;
    // padding:0 20%;
    width: calc(100% - 12px);
    //  background: #fff;
    // background-color: red;
    width: 100%;

    /deep/ .el-tabs {
      display: none;
    }

    .select-right {
      display: block
    }

    .top-box {
      height: 70px;
      width: 100%;
      margin: 0 auto;

      display: flex;
      justify-content: space-between;

    }
  }

  .bottom {
    background-color: #f2f2f2;

    .bottom-content {
      width: 100%;

      .info {
        justify-content: start;
        padding: 0 0 5px 20px;
        border: none;

        .info-item {
          font-size: 13px;

          .text {
            border-bottom: 1px solid #bbbbbb;
          }

          &:nth-child(n+2) {
            // background-color: red;
            display: none
          }
        }
      }

      .about {
        .about-link {
          display: none;
        }

        .copy-info {
          font-size: 13px;
          // padding-left: 20px;
          color: #a9a9a9;


        }

        .un-show {
          display: none;
        }


        .un-show.phone {
          display: block;
        }

        .number-box {
          display: none;
        }
      }
    }
  }

  .bottom-btn {
    display: block;

    .btn-box {
      display: flex;
      justify-content: space-around;
      font-size: 12px;
      padding: 15px;

      .item-box {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        color: #747577;

        .icon-box {
          // font-size: 26px;
        }
      }
    }
  }
}
</style>
